<script setup>
//import { ref } from 'vue'
import { addIcon, deleteIcon, draggableIcon } from '../../utils/icons';
import { useTestStore } from '../../stores/TestStore';
import { useDraggable } from '../../composables/draggable.js'

const testStore = useTestStore();

const { draggedItem, dragOverItem, handleDragStart, handleDragOver, handleDragReset, handleDragEnd } = useDraggable()

// Como las respuestas están separadas por secciones, no es tan sencillo como en "dimensiones" o "secciones"
// Donde únicamente tenía que ver el "index", lo posición que ocupaban en el array.
// Ahora tendré que cambiar también la sección de elemento.
function handleDrop(pregunta_id_drop) {
  let pregunta_origen_index = testStore.test.preguntas.findIndex((p) => p.id == draggedItem.value);
  let pregunta_destino_index = testStore.test.preguntas.findIndex((p) => p.id == pregunta_id_drop);

  // Igualamos las secciones, tendrán que tener siempre la misa sección ya que ha aterrizado ahí.
  testStore.preguntas[pregunta_origen_index].seccion_id = testStore.preguntas[pregunta_destino_index].seccion_id;
  
  // Cambio la posición del origen
  testStore.aux_cambia_posicion(testStore.preguntas, pregunta_origen_index, pregunta_destino_index);
  
  handleDragReset()
}

</script>

<template>

  <div class="preguntas-test my-5">
    
    <div class="flex justify-between border-b-2 mb-5 pb-2">
      <h5 class="font-bold text-blue-700">Preguntas</h5>
      <button class="button-text-icon-sm" type="button" @click="testStore.add_pregunta(seccion)">
        <i v-html='addIcon'></i><span class="mx-2">Añadir</span>
      </button>
    </div>

    <div class="leyenda-test mb-1" >
      <div class="flex space-x-4 font-bold">
       <span class="w-5/12">Pregunta</span>
       <span class="w-2/12">Dimensión</span>
       <span class="w-1/12">Sección</span>
       <span class="w-1/12">Modo pun</span>
       <span class="w-1/12">Peso</span>
      </div>
    </div> 

    <div class="sortable-list">
      
      <div 
        v-for="pregunta in testStore.preguntas" :key="pregunta.id"
        class="pregunta-test mb-1 flex flex-row space-x-4"
        :draggable="true"
        @dragstart="handleDragStart(pregunta.id)"
        @dragover="handleDragOver($event, pregunta.id)"
        @drop="handleDrop(pregunta.id)"
        @dragend="handleDragEnd"
        :class="{ 'bg-blue-200': pregunta.id === draggedItem, 'border-2 border-dashed border-blue-200': pregunta.id == dragOverItem && pregunta.id != draggedItem }"
        >
        
        <div class="w-5/12"><input class="input-f" v-model="pregunta.text" type="text" placeholder="¿...?"></div>
        
        <div class="w-2/12">
          <select v-model="pregunta.dimension_id" class="select-f">
            <option v-for="dimension in testStore.dimensiones" :value="dimension.id" :key="dimension.id">{{ dimension.nombre }}</option>
          </select>
        </div>

        <div class="w-1/12">
          <select v-model="pregunta.seccion_id" class="select-f"  :class="{ 'bg-red-100': testStore.secciones.filter((sec) => sec.id == pregunta.seccion_id).length < 1}">
            <option v-for="seccion in testStore.secciones" :value="seccion.id" :key="seccion.id">{{ seccion.nombre }}</option>
          </select>
        </div>
        
        <div class="w-1/12">
          <select v-model="pregunta.modo_puntuacion" class="select-f">
            <option value="directo">Directo</option>
            <option value="inverso">Inverso</option>
          </select>
        </div>
        
        <div class="w-1/12">
          <input class="input-f" v-model="pregunta.peso" type="number" placeholder="Peso">
        </div>
        
        <div class="w-12">
          <span class="button-icon-out-gray-red" type="button" @click="testStore.delete_pregunta(pregunta.id)">
            <i v-html='deleteIcon'></i>
          </span>    
        </div>
        
        <div class="w-12">
          <span class="button-icon-out-gray-blue" type="button"><i v-html='draggableIcon'></i></span>    
        </div>

      </div>

    </div>
  </div>
  
</template>
 
<style lang="scss">

</style>